import { render, staticRenderFns } from "./StepFifteen.vue?vue&type=template&id=2a010efc&"
import script from "./StepFifteen.vue?vue&type=script&lang=js&"
export * from "./StepFifteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports